module.exports = __webpack_public_path__ + "img/CF_1M.1.45d5b679.jpg";